import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { StaffManagerListItem } from "../../staff.types";
import { ApiRoutesStaff } from "./../../constants";

export const requestGetStaffManagers = async (
  params: GetListRequestParams
): Promise<GetListResponse<StaffManagerListItem>> => {
  return await instance.get(ApiRoutesStaff.AllStaffManagers, { params });
};
